function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.29 8.187L1.093.077a.735.735 0 00-.795.09.737.737 0 00-.243.737l1.95 7.202h8.327V9.58H2.006l-1.98 7.18a.738.738 0 00.736.93.736.736 0 00.331-.081l16.197-8.11a.736.736 0 000-1.312z",
  fill: "#BDBFC1"
});
function SvgSendMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgSendMessage;